import { render, staticRenderFns } from "./Bd.vue?vue&type=template&id=51874436"
import script from "./Bd.vue?vue&type=script&lang=ts"
export * from "./Bd.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports